import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {ObjectIdModule} from '../../modules/models'
import {BathRoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function deleteBathRoomService(dto: ObjectIdModule[]) {
  return await axios.delete<ResponseObject<BathRoomModel>>(`${BASEURL}/bathRoom/deleteBathRoom`, {
    data: dto,
  })
}
